import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin, Calendar, Users } from "lucide-react";

const ICONS = {
  calendar: Calendar,
  "map-pin": MapPin,
  users: Users,
};

export const OPENHOUSE_DEFAULT_DATA = {
  hero_image: "/api/media/c264013f-517c-4d93-9df3-4e63798f2fa2",
  hero_image_alt: "Antera Open House",
  title_lead: "Antera",
  title_accent: "Open House",
  tagline: "Join us at our new headquarters in Plano, Texas for an exclusive look at the future of Antera Software. Meet the team, see live product demos, and connect with fellow industry professionals.",
  info_cards: [
    { icon: "calendar", title: "Date",     desc: "Contact us for upcoming dates" },
    { icon: "map-pin",  title: "Location", desc: "Plano, Texas" },
    { icon: "users",    title: "Who",      desc: "Clients, Partners & Prospects" },
  ],
  cta_label: "Register Interest",
  cta_href: "/contact",
};

export default function OpenHousePage({ data }) {
  const src = data || {};
  const d = { ...OPENHOUSE_DEFAULT_DATA, ...src };
  const cards = Array.isArray(src.info_cards) && src.info_cards.length > 0
    ? src.info_cards
    : OPENHOUSE_DEFAULT_DATA.info_cards;

  return (
    <div data-testid="openhouse-page" className="page-transition">
      <section className="pt-32 pb-14 lg:pt-40 lg:pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-center">
            {d.hero_image ? (
              <div className="rounded-xl overflow-hidden shadow-lg mb-10">
                <img src={d.hero_image} alt={d.hero_image_alt} className="w-full h-auto" />
              </div>
            ) : null}
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
              {d.title_lead} <span className="text-sky-600">{d.title_accent}</span>
            </h1>
            <p className="mt-5 text-base lg:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto">
              {d.tagline}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-14 lg:py-20 bg-slate-50/50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {cards.map((c, i) => {
              const Icon = ICONS[c.icon] || Calendar;
              return (
                <div key={c.title || i} className="bg-white border border-slate-200 rounded-lg p-6 text-center">
                  <Icon className="h-8 w-8 text-sky-600 mx-auto mb-3" />
                  <h3 className="text-base font-bold text-slate-900">{c.title}</h3>
                  <p className="text-sm text-slate-500 mt-1">{c.desc}</p>
                </div>
              );
            })}
          </div>

          {d.cta_label ? (
            <div className="text-center">
              <Link to={d.cta_href || "/contact"}>
                <Button className="bg-sky-600 hover:bg-sky-700 text-white rounded-full px-8 h-12 text-sm font-semibold">
                  {d.cta_label} <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
          ) : null}
        </div>
      </section>
    </div>
  );
}
